import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

import { Map } from '../../shared/types'
import { RootState } from '../../app/store'
import { fetchData } from '../../shared/api/api'
import { GetMapByIdRequest, GetMapByIdResponse } from './types'

export const fetchMapById = createAsyncThunk<
  GetMapByIdResponse,
  GetMapByIdRequest,
  { state: RootState } // ThunkAPI config
>('map/fetchMapById', async (mapId, thunkAPI) => {
  const state = thunkAPI.getState()
  const zoneId = state.zone?.data?.id

  try {
    const response = await fetchData<GetMapByIdResponse>(
      `/zones/${zoneId}/maps/${mapId}`
    )
    return response
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data || error.message)
  }
})
